import { cn } from '@/lib/cn'

// Skeleton renders a single placeholder bar. SR users get the
// "Loading" announcement via role=status + aria-live=polite on the
// element itself — callers stacking many skeletons in one region can
// instead wrap them in a single SkeletonGroup so screen readers
// don't echo the announcement once per bar.
export function Skeleton({
  className,
  'aria-label': ariaLabel,
  role,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded bg-muted', className)}
      role={role ?? 'status'}
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel ?? 'Loading'}
      {...props}
    />
  )
}

// SkeletonGroup wraps several Skeleton children in a single status
// region so the loading announcement fires once. Children pass
// role={undefined} to suppress their own announcement.
export function SkeletonGroup({
  className,
  label = 'Loading',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
      className={className}
      {...props}
    >
      {children}
    </div>
  )
}
